export default __webpack_public_path__ + "static/media/exterior6.9b2fa46c.jpg";